export default __webpack_public_path__ + "fonts/Gotham-Light.f77afa1f04dac757e566e35009b405f5.woff2";